
import { commonRoutes } from './commonRoutes';

export const stakeholderManagementRoutes = {
  STAKEHOLDER_MANAGEMENT: '/smp',
  get LOGIN() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.LOGIN}`;
  },
  get REGISTER() {
    return `${this.STAKEHOLDER_MANAGEMENT}/register`;
  },
  get FORGOT_PASSWORD() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.FORGOT_PASSWORD}`;
  },
  get CREATE_PASSWORD() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.CREATE_PASSWORD}`;
  },
  get RESET_PASSWORD() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.RESET_PASSWORD}`;
  },
  get DASHBOARD() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.DASHBOARD}`;
  },
  get PROFILE() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.PROFILE}`;
  },
  get SH_REQUESTS() {
    return `${this.STAKEHOLDER_MANAGEMENT}/stakeholder-requests`;
  },
  get ADD_SH_REQUESTS() {
    return `${this.STAKEHOLDER_MANAGEMENT}/add-stakeholder-request`;
  },
  get SHs() {
    return `${this.STAKEHOLDER_MANAGEMENT}/stakeholders`;
  },
  get SHs_REQUESTS() {
    return `${this.STAKEHOLDER_MANAGEMENT}/stakeholders-Request`;
  },
  get EDIT_SH() {
    return `${this.STAKEHOLDER_MANAGEMENT}/edit-stakeholder`;
  },
  get DRUGS() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.DRUGS}`;
  },
  get VIEW_DRUG() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.VIEW_DRUG}`;
  },
  get REPORT() {
    return `${this.STAKEHOLDER_MANAGEMENT}/report-summary`;
  },
  get STOCK_SUMMARY() {
    return `${this.STAKEHOLDER_MANAGEMENT}/stock-summary`;
  },
  get SH_OPERATIONAL_SUMMARY() {
    return `${this.STAKEHOLDER_MANAGEMENT}/stakeholder-operational-summary`;
  },
  get INTEGRATION_DOC() {
    return `${this.STAKEHOLDER_MANAGEMENT}/integration-doc`;
  },
  get UPDATE_PROFILE() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.UPDATE_PROFILE}`;
  },
  get UNREGISTERED_DRUGS_REQUESTS() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.UNREGISTERED_DRUGS_REQUESTS}`;
  },
  get ADD_UNREGISTERED_DRUGS_REQUESTS() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.ADD_UNREGISTERED_DRUGS_REQUESTS}`;
  },
  get EDIT_UNREGISTERED_DRUGS_REQUESTS() {
    return `${this.STAKEHOLDER_MANAGEMENT}/${commonRoutes.EDIT_UNREGISTERED_DRUGS_REQUESTS}`;
  },
  get SMP_STOCK_MATCH_LOG_LIST() {
    return `${this.STAKEHOLDER_MANAGEMENT}/stock-match-log-list`;
  },
  get SMP_STOCK_MATCH_LOG_DETAILS() {
    return `${this.SMP_STOCK_MATCH_LOG_LIST}/:id`;
  },
  get PREMIUM_DRUGS() {
    return `${this.STAKEHOLDER_MANAGEMENT}/premium-drugs`;
  }
};


export const stakeholderManagementbreadcrumbTitlesKey = {
  [stakeholderManagementRoutes.STAKEHOLDER_MANAGEMENT]: 'pageTitles.stakeholderManagementPortal',
  [stakeholderManagementRoutes.LOGIN]: 'pageTitles.login',
  [stakeholderManagementRoutes.DASHBOARD]: 'pageTitles.dashboard',
  [stakeholderManagementRoutes.DRUGS]: 'pageTitles.drugs',
  [stakeholderManagementRoutes.REGISTER]: 'pageTitles.register',
  [stakeholderManagementRoutes.PROFILE]: 'pageTitles.profile',
  [stakeholderManagementRoutes.SH_REQUESTS]: 'pageTitles.stakeholderRequests',
  [stakeholderManagementRoutes.ADD_SH_REQUESTS]: 'pageTitles.addStakeholderRequest',
  [stakeholderManagementRoutes.SHs]: 'pageTitles.stakeholders',
  [stakeholderManagementRoutes.SHs_REQUESTS]: 'pageTitles.stakeholders',
  [stakeholderManagementRoutes.EDIT_SH]: 'pageTitles.editStakeholder',
  [stakeholderManagementRoutes.VIEW_DRUG]: 'pageTitles.viewDrug',
  [stakeholderManagementRoutes.STOCK_SUMMARY]: 'pageTitles.stockSummary',
  [stakeholderManagementRoutes.SH_OPERATIONAL_SUMMARY]: 'pageTitles.stakeholderOperationSummary',
  [stakeholderManagementRoutes.INTEGRATION_DOC]: 'pageTitles.integrationDocuments',
  [stakeholderManagementRoutes.UPDATE_PROFILE]: 'pageTitles.StakeholderManagementUpdateProfile',
  [stakeholderManagementRoutes.UNREGISTERED_DRUGS_REQUESTS]: 'pageTitles.unRegisteredDrugsRequests',
  [stakeholderManagementRoutes.ADD_UNREGISTERED_DRUGS_REQUESTS]: 'pageTitles.addUnregisteredDrugRequest',
  [stakeholderManagementRoutes.EDIT_UNREGISTERED_DRUGS_REQUESTS]: 'pageTitles.editUnregisteredDrugRequest',
  [stakeholderManagementRoutes.SMP_STOCK_MATCH_LOG_LIST]: 'pageTitles.stockMatchLogList',
  [stakeholderManagementRoutes.SMP_STOCK_MATCH_LOG_DETAILS]: 'pageTitles.stockMatchLogDetails',
  [stakeholderManagementRoutes.PREMIUM_DRUGS]: 'pageTitles.premiumDrugs'
};

